import React from 'react';
import {
    TextField,
    MenuItem,
    InputAdornment,
    IconButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const StyledSelect = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        fontSize: '0.9rem',

        '& fieldset': {
            borderColor: theme.palette.divider,
        },
        '&:hover fieldset': {
            borderColor: theme.palette.text.disabled,
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
            borderWidth: 1.5,
        },
        '& .MuiSelect-select': {
            paddingRight: '36px !important',
            padding: '10px 12px',
        },
    },

    '& .MuiInputLabel-root': {
        fontSize: '0.85rem',
        fontWeight: 500,
    },
}));

const StyledMenuItem = styled(MenuItem)({
    fontSize: '0.9rem',
    padding: '10px 12px',
});

const LsSelect = ({
                      label,
                      options = [],
                      value,
                      onChange,
                      placeholder = 'Select...',
                      required = false,
                      error = false,
                      helperText,
                      size = 'small',
                      allowClear = true,
                      MenuProps,
                      ...props
                  }) => {
    const hasValue = Boolean(value);
    const showClear = allowClear && hasValue;

    const handleClear = (e) => {
        e.stopPropagation();
        onChange({ target: { value: '' } });
    };

    return (
        <StyledSelect
            select
            fullWidth
            label={label}
            value={value || ''}
            onChange={onChange}
            required={required}
            error={error}
            helperText={helperText}
            size={size}
            SelectProps={{
                displayEmpty: true,
                IconComponent: ArrowDropDownIcon,
                MenuProps: {
                    disableScrollLock: true,
                    ...MenuProps,
                    PaperProps: {
                        ...MenuProps?.PaperProps,
                        sx: {
                            maxHeight: 260,
                            ...MenuProps?.PaperProps?.sx,
                        },
                    },
                },
                renderValue: (val) => {
                    if (!val) {
                        // Use theme token for placeholder color
                        return <span style={{ color: 'var(--placeholder-color)' }}>{placeholder}</span>;
                    }
                    const match = options.find(o => o.value === val);
                    return match?.label || val;
                },
            }}
            // Inject CSS variable via sx so theme is respected
            sx={{
                '--placeholder-color': 'var(--mui-palette-text-disabled, #9CA3AF)',
            }}
            InputProps={{
                endAdornment: showClear ? (
                    <InputAdornment position="end" sx={{ position: 'absolute', right: 28 }}>
                        <IconButton
                            size="small"
                            onMouseDown={handleClear}
                            tabIndex={-1}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ) : null,
            }}
            {...props}
        >
            <StyledMenuItem value="">
                <em>{placeholder}</em>
            </StyledMenuItem>

            {options.map((option) => (
                <StyledMenuItem key={option.value} value={option.value}>
                    {option.label}
                </StyledMenuItem>
            ))}
        </StyledSelect>
    );
};

export default LsSelect;